import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-376a07dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none",
  style: {"max-width":"320px"}
}
const _hoisted_2 = { class: "flex-1 min-w-0" }
const _hoisted_3 = { class: "font-semibold text-sm leading-tight" }
const _hoisted_4 = { class: "text-xs text-muted leading-tight mt-0.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "reward-toast" }, {
    default: _withCtx(() => [
      (_ctx.visible && _ctx.events.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedEvents, (event, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "reward-toast-item flex items-center gap-3 bg-white rounded-xl shadow-lg px-4 py-3 border border-gray-100"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["shrink-0 w-10 h-10 rounded-full flex items-center justify-center", _ctx.eventBgColor(event)])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["material-icons", _ctx.eventIconColor(event)]),
                    style: {"font-size":"22px"}
                  }, _toDisplayString(_ctx.eventIcon(event)), 3)
                ], 2),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.eventTitle(event)), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.eventSubtitle(event)), 1)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}